import { mapActions, mapGetters } from "vuex";
import PreviewDocument from "@/shared/PreviewDocument/PreviewDocument";

export default {
	components: { PreviewDocument },
	computed: mapGetters([ 'previewLink' ]),
	data: () => ({
		link: null
	}),
	methods: mapActions([ 'onPreview' ])
};
